import { useQuery } from '@apollo/client'
import { BuscaBibliotecaPageQuery } from '../../../core/types/graphql'
import { BUSCA_QUERY } from '../data/busca-query'

export const useTabelaBuscaArquivo = ({ searchText, pagination }) => {
  const { data: { buscaBibliotecaPaged } = {}, loading } =
    useQuery<BuscaBibliotecaPageQuery>(BUSCA_QUERY, {
      variables: {
        filterInput: {
          busca: searchText,
          page: pagination.pageIndex,
          rowsPerPage: pagination.pageSize
        }
      }
    })

  return { buscaBibliotecaPaged, loading }
}
